export const GET_PROJECT_SUCCESS = "GET_PROJECT_SUCCESS"
export const GET_PROJECT_FAILURE = "GET_PROJECT_FAILURE"
export const GET_PROJECT_REQ = "GET_PROJECT_REQ"

export const GET_INDIVIDUAL_PROJ_SUCCESS = "GET_INDIVIDUAL_PROJ_SUCCESS"
export const GET_INDIVIDUAL_PROJ_REQ = "GET_INDIVIDUAL_PROJ_REQ"


export const POST_PROJECT_SUCCESS = "POST_PROJECT_SUCCESS"
export const POST_PROJECT_FAILURE = "POST_PROJECT_FAILURE"
export const POST_PROJECT_REQ = "POST_PROJECT_REQ"

export const DELETE_PROJECT_SUCCESS = "DELETE_PROJECT_SUCCESS"
export const DELETE_PROJECT_FAILURE = "DELETE_PROJECT_FAILURE"
export const DELETE_PROJECT_REQ = "DELETE_PROJECT_REQ"